// Only the styles for the Element Plus components actually used (Tree, TreeSelect), not the
// whole component library. tree-select's own style/css.mjs already imports tree + select (and
// their transitive deps), so importing it alone covers both ElTree (CatalogTree.vue) and
// ElTreeSelect (components/catalog/CatalogSelect.vue) usages.
// Must come BEFORE front.scss: Vite/Rollup concatenates eagerly-imported CSS in import order, and
// _el-tree-select.scss overrides some of Element's own literal (non custom-property) declarations
// (e.g. .el-select__wrapper's min-height/padding) — those need to appear later in the cascade to
// win, since same-selector same-specificity ties resolve by source order.
import 'element-plus/es/components/tree-select/style/css';
import './styles/front.scss';

import { createApp } from 'vue';
import App from './components/App.vue';
import router from './router';
import { i18n } from './composables/I18n';
import { installGlobalErrorHandler } from './services/globalErrorHandler';
import { initTheme } from './composables/useTheme';

// Vzhled (docs/tasks/design/plan-001.md) — dřív než se aplikace vykreslí, ať stránka neblikne ve výchozím vzhledu.
initTheme();

document.addEventListener('DOMContentLoaded', () => {
	const app = createApp(App).use(router).use(i18n);
	installGlobalErrorHandler(app);
	app.mount('#app');
});
